import { Show as RaShow, ShowProps as RaShowProps } from 'react-admin';

export const Show = RaShow;

export type ShowProps = RaShowProps;
